import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { MobileService } from '../services/mobile.service';
import { MODULE_WRAPPER_VIEW_MODE_CLASSES } from '../constants';

@UntilDestroy()
@Directive({
  selector: '[lmsApprovalWrapperViewModeClasses]',
})
export class WrapperViewModeClassesDirective implements AfterViewInit {
  readonly mobileViewModeClass = MODULE_WRAPPER_VIEW_MODE_CLASSES.mobile;
  readonly desktopViewModeClass = MODULE_WRAPPER_VIEW_MODE_CLASSES.desktop;

  private classTarget?: Element;

  constructor(private elementRef: ElementRef<HTMLElement>, private mobileService: MobileService) {}

  ngAfterViewInit(): void {
    this.startObserving();
  }

  private startObserving(): void {
    this.classTarget = this.elementRef.nativeElement;
    this.updateClassesOnViewModeChange();
  }

  private updateClassesOnViewModeChange(): void {
    this.mobileService
      .isMobile$()
      .pipe(untilDestroyed(this))
      .subscribe((isMobile) => {
        if (isMobile) {
          this.setMobileModeClassName();

          return;
        }

        this.setDesktopModeClassName();
      });
  }

  private setMobileModeClassName(): void {
    if (!this.classTarget) {
      return;
    }

    this.classTarget.classList.remove(this.desktopViewModeClass);
    this.classTarget.classList.add(this.mobileViewModeClass);
  }

  private setDesktopModeClassName(): void {
    if (!this.classTarget) {
      return;
    }

    this.classTarget.classList.remove(this.mobileViewModeClass);
    this.classTarget.classList.add(this.desktopViewModeClass);
  }
}
